// @ts-check
if (!window.AndDaughter) {
  window.AndDaughter = {};
}

window.AndDaughter.productGallery = function () {
  /**
   * @param Record<string, number>
   * List of values in PX
   */
  const breakpoints = {
    gallery: 999,
  };

  /**
   * @param {NodeListOf<Element>}
   * an element just before the add to cart button element
   * this element is static on the page and has a non-brekaing space in it so its position can be calculated with getBoundingClientRect()
   */
  const imagesLinks = document.querySelectorAll("[data-js-open-gallery]");

  /**
   * @param {HTMLElement}
   */
  const closeButton = document.querySelector("[data-js-close-gallery]");

  /**
   * @param {HTMLElement | null}
   * the content/modal of the size guide
   */
  let modal = document.querySelector("[data-js-product-gallery]");

  /**
   * @param {HTMLElement | null}
   */
  let lastFocusedItem = null;

  /**
   * Actions when an image is clicked
   * @param {Event} event
   *
   * @return {void}
   */
  const handleClickImageLink = (event) => {
    if (breakpoints.gallery >= document.documentElement.clientWidth) {
      return;
    }
    event.preventDefault();

    const imageId = event.currentTarget?.getAttribute("data-thumbnail-id");

    // Remove lazyload from img tags so they all load as soon as the first one is clicked
    // loading="lazy" is good because we leave all the HTML on the product page and this way
    // the images aren't loaded unless the user clicks on the gallery
    Array.from(modal?.querySelectorAll("img")).forEach((img) => {
      img.removeAttribute("loading");
    });

    modal?.removeAttribute("hidden");

    lastFocusedItem = event.currentTarget;

    // Reset the scroll of the `position:fixed/overflow:auto` container
    // then focus the clicked image (so the user is looking at the image they want)
    // then focus the close button so the user can easily close with the keyboard
    // then hide any elements we don't want the user tabbing to.
    // modal.scrollTo(0, 0);

    const image = document.getElementById(`Image-${imageId}`);

    if (image) {
      image.setAttribute("tabindex", "-1");
      image.focus();
      image.removeAttribute("tabindex");
    }
    // then wait a while and focus the close button to make it easier for a11y to close the gallery
    setTimeout(function () {
      closeButton?.focus();
    }, 500);
  };

  /**
   * close the gallery
   *
   * @return {void}
   */
  const handleClose = () => {
    if (!modal) {
      return;
    }

    modal.setAttribute("hidden", "true");

    if (lastFocusedItem) {
      lastFocusedItem.focus();
    }
  };

  /**
   * Handle keydown events, only used to handle Esc key which should close the gallery
   *
   * @return {void}
   */
  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      // if esc key was not pressed in combination with ctrl or alt or shift
      const isNotCombinedKey = !(
        event.ctrlKey ||
        event.altKey ||
        event.shiftKey
      );
      if (isNotCombinedKey) {
        handleClose();
      }
    }
  };

  /**
   * Add and remove event listeners that will trigger actions on the elements
   *
   * @returns {void}
   */
  const addEventListeners = () => {
    // open image on link click
    for (let i = 0; i < imagesLinks.length; i++) {
      imagesLinks[i].removeEventListener("click", handleClickImageLink);
      imagesLinks[i].addEventListener("click", handleClickImageLink);
    }

    // click/tap close = close
    closeButton?.removeEventListener("click", handleClose);
    closeButton?.addEventListener("click", handleClose);

    // Press Esc = close
    document.removeEventListener("keydown", handleKeyDown);
    document.addEventListener("keydown", handleKeyDown);
  };

  /**
   * Scripts/tasks that run when object is first created
   *
   * @returns {void}
   */
  const init = () => {
    if (!imagesLinks || imagesLinks.length === 0) {
      return;
    }
    addEventListeners();
  };

  return {
    init,
  };
};

window.AndDaughter.productGallery().init();
